import type { Ref } from "react"
import { DragPreview, type DragPreviewRenderer } from "react-aria"

/**
 * react-aria's drag preview, fed a transparent 1×1 spacer so the browser's NATIVE drag image
 * paints nothing: Chrome dims every native image, and a transform would drift it off the grab
 * point. The visible ghost is the follower card (use-lesson-drag-ghost.tsx) instead.
 */
export default function BlankNativeDragImage({ ref }: { ref: Ref<DragPreviewRenderer | null> }) {
  return (
    <DragPreview ref={ref}>
      {() => (
        <img
          alt=""
          width={1}
          height={1}
          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
        />
      )}
    </DragPreview>
  )
}
